import { EnableRuleAction } from './EnableRuleAction';
import { EnableRuleSuccessAction } from './EnableRuleSuccessAction';
import { DisableRuleAction } from './DisableRuleAction';
import { DisableRuleSuccessAction } from './DisableRuleSuccessAction';
import { UpdateRuleStatusAction } from './UpdateRuleStatusAction';
import { UpdateRuleStatusSuccessAction } from './UpdateRuleStatusSuccessAction';
import { QueryListByModuleAction } from './QueryListByModuleAction';
import { UpdateRuleParameterAction } from './UpdateRuleParameterAction';
import { UpdateRuleParameterSuccessAction } from './UpdateRuleParameterSuccessAction';
import { GetParametersAction } from './GetParametersAction'
import { GetParametersSuccessAction } from './GetParametersSuccessAction'
import { GetDataSetsAction } from './GetDataSetsAction';
import { GetDataSetsSuccessAction } from './GetDataSetsSuccessAction';
import { GetComparisonDateAction } from './GetComparisonDateAction';
import { GetComparisonDateSuccessAction } from './GetComparisonDateSuccessAction';
import { ApplyCommonParametersAction } from './ApplyCommonParametersAction';
import { ApplyCommonParametersSuccessAction } from './ApplyCommonParametersSuccessAction';
import { GetCommonParametersAction } from './GetCommonParametersAction';
import { GetCommonParametersSuccessAction } from './GetCommonParametersSuccessAction';

export type Actions = EnableRuleAction | EnableRuleSuccessAction | DisableRuleAction | DisableRuleSuccessAction | UpdateRuleStatusAction | UpdateRuleStatusSuccessAction | UpdateRuleParameterAction | UpdateRuleParameterSuccessAction | GetParametersAction | GetParametersSuccessAction | GetDataSetsAction | GetDataSetsSuccessAction | GetComparisonDateAction | GetComparisonDateSuccessAction | ApplyCommonParametersAction | ApplyCommonParametersSuccessAction | GetCommonParametersAction | GetCommonParametersSuccessAction;
export type TypedActions<TModel> = QueryListByModuleAction<TModel>

export * from './EnableRuleAction';
export * from './EnableRuleSuccessAction';
export * from './DisableRuleAction';
export * from './DisableRuleSuccessAction';
export * from './UpdateRuleStatusAction';
export * from './UpdateRuleStatusSuccessAction';
export * from './QueryListByModuleAction';
export * from './UpdateRuleParameterAction';
export * from './UpdateRuleParameterSuccessAction';
export * from './GetParametersAction';
export * from './GetParametersSuccessAction';
export * from './GetDataSetsAction';
export * from './GetDataSetsSuccessAction';
export * from './GetComparisonDateAction';
export * from './GetComparisonDateSuccessAction';
export * from './ApplyCommonParametersAction';
export * from './ApplyCommonParametersSuccessAction';
export * from './GetCommonParametersAction';
export * from './GetCommonParametersSuccessAction';



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/index.ts